// extracted by mini-css-extract-plugin
module.exports = {"textBold":"Text_textBold__2ePi4","textNormal":"Text_textNormal__Gch1n"};